import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbDangerousStringToDate,
    bbDictionaryOfClientStatusTags,
    bbFindEntityWithinPortfolioOrSelf,
} from "../../../util/bbHelpers";
import {CircularProgress, Dialog, DialogContent, DialogTitle, IconButton, MenuItem, } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {Button, Col, Row} from "reactstrap";
import {useForm} from "react-hook-form";
import {tagVectorClientStatusAdd, tagVectorClientStatusUpdate, tagVectorCommentAdd} from "../../../actions";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";

const VectorClientStatusSelect = ({customerId,
                                      entityId,
                                      vectorId = null,
                                      testedVectorId,
                                      cycleId=null
                                      })=>{

    const {loadingAddTag, loadingAddTagError, loadingUpdateTag, loadingUpdateTagError} = useSelector(({common})=> common);

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, loadingPortfoliosError, loadingCycles, loadingCyclesError, loadingCycleDetails, loadingCycleDetailsError, selfEntityId} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);


    const lastCycle = myEntity
    && myEntity.cycles
    && myEntity.settings
    && myEntity.settings.last_cycle_id
        ? myEntity.cycles[myEntity.settings.last_cycle_id]
        : null;

    const lastCycleDate = lastCycle && lastCycle.summary && lastCycle.summary.cycle_datetime ? bbDangerousStringToDate(lastCycle.summary.cycle_datetime) : null

    const pastReportView = cycleId && lastCycle && cycleId !== lastCycle.id;

    const cycleInView = pastReportView
    && myEntity
    && myEntity.cycles
    && myEntity.cycles[cycleId]
        ? myEntity.cycles[cycleId]
        : lastCycle;

    const techData = myEntity
    && (lastCycle || cycleInView)
        ? cycleInView.techData
        : null;

    //in tech data, the threat vectors must be pulled from the techData, which holds more data than the BR Reports page
    const threatVectors = techData
    && techData.totals
        ? techData.totals.vectors
        : null;

    const vector = threatVectors
    && threatVectors.find(x=> x.id === vectorId)
        ? threatVectors.find(x=> x.id === vectorId)
        : null;    // console.log( "VectorScopeToggle tags", tags, "loadingAddTag", loadingAddTag, "testedVectorId", testedVectorId, "vectorId", vectorId)

    // const indexOfVector = threatVectors && vectorId && threatVectors.findIndex(x => x.id === vectorId);

    const testedVectorDetails = vector
        && vector.tested_vector_details;

    const tags = testedVectorDetails
        && testedVectorDetails.tags
        && Object.values(testedVectorDetails.tags);

    const statusTag = tags
        ? tags
            .filter((tag)=> tag.definition && tag.definition.id === 44)
        : null;

    const hasStatus = statusTag && Object.values(statusTag).length > 0;

    const latestStatus = hasStatus
        ? statusTag
            .sort((a,b)=> b.date - a.date)
            .slice(0,1)
            .shift()
        : null

    const [statusType, setStatusType] = useState(hasStatus && latestStatus && latestStatus.details ? latestStatus.details : 0);
    const [open, setOpen] = useState(false);

    const dispatch = useDispatch();

    const statusTagTypesArray = Object.values(bbDictionaryOfClientStatusTags);

    const handleChange = (statusType) => {
        setStatusType(statusType);
        setOpen(true);
    }

    const handleClose = () =>{
        setStatusType(hasStatus && latestStatus && latestStatus.details ? latestStatus.details : 0)
        setOpen(false);
    }

    const { register, handleSubmit, errors } = useForm();

    const onSubmit = data => {
        if(hasStatus && statusType !== "0"){
            // console.log("updating old tag to inactive, adding new tag")
            dispatch(tagVectorClientStatusUpdate(customerId, entityId, vectorId, testedVectorId, latestStatus))
            dispatch(tagVectorClientStatusAdd(
                    customerId,
                    entityId,
                    vectorId,
                    testedVectorId,
                    statusType,
                    false))
        } else if(hasStatus && statusType === "0"){
            // console.log("updating status tag, type selected === 0, all tag set inactive")
                    dispatch(tagVectorClientStatusUpdate(customerId, entityId, vectorId, testedVectorId, latestStatus))
        }else {
            // console.log("no previous status, adding new status tag")
            dispatch(tagVectorClientStatusAdd(
                    customerId,
                    entityId,
                    vectorId,
                    testedVectorId,
                    statusType,
                    true))
        }
    setOpen(false);
    }

    return(
        <div>
            {!loadingAddTag[vectorId]
            && !loadingAddTagError[vectorId]
            && !loadingUpdateTag[testedVectorId]
                ? <Tooltip title={`Select a status for this element.`}>
                <select onChange={(e)=>handleChange(e.target.value)}
                    id="statusType"
                    name="statusType"
                        disabled={pastReportView}
                    value={statusType}>
                {statusTagTypesArray.map((statusType)=>
                    <option key={statusType.id}
                            value={statusType.value}>
                        {statusType.label}
                    </option>
                )}
            </select>
                </Tooltip>
                : <CircularProgress size={16}/>}
            {/*{pastReportView && <p><small>Disabled</small></p>}*/}

            <Dialog open={open}
                    fullScreen={false}
                    maxWidth={"md"}
                    className={"m-1 p-1 animated fadeIn animation-duration-7"}
                    aria-labelledby="form-dialog-title"
                    >
                <DialogTitle id="customized-dialog-title" className={"text-center"}>
                    <h1>Change Status
                        <IconButton
                            onClick={handleClose}
                            style={{float: "right", margin: "0", padding: "0"}}>
                            <CloseIcon/>
                        </IconButton>
                    </h1>
                </DialogTitle>
                <DialogContent>
                    <div className={"text-center"}>
                        <h3>Are you sure you want to set the status to {statusType && bbDictionaryOfClientStatusTags[statusType].label}?</h3>
                    </div>
                    <p style={{fontSize: "12px"}}><em>Use this feature to track investigation into and resolution of threats.
                        Changes to the issue status are for internal use in your company only.</em></p>
                        <Row className={"m-1 p-1 text-center"}>
                        <Col lg={12}>
                            <Button onClick={handleSubmit(onSubmit)}
                                    variant="contained" color="primary"
                                    type="submit">
                                Confirm
                            </Button>
                            <Button onClick={handleClose}
                                    variant="contained" color="primary">
                                Cancel
                            </Button>
                        </Col>
                    </Row>
                </DialogContent>
            </Dialog>
        </div>
    )

}

export default VectorClientStatusSelect;